import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES } from "../mock";
import { useReveal } from "../hooks/useReveal";
import { Check } from "lucide-react";

const Intro = () => {
  const { t } = useLanguage();
  const a = useReveal();
  const b = useReveal();

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 sm:gap-16 items-center">
        <div ref={b.ref} className={`${b.className} order-2 lg:order-1`}>
          <div className="grid grid-cols-2 gap-4">
            <img
              src={IMAGES.meditation}
              alt="Meditazione"
              className="rounded-2xl h-48 sm:h-64 w-full object-cover shadow-lg mt-8"
            />
            <img
              src={IMAGES.mudra}
              alt="Armonia energetica"
              className="rounded-2xl h-48 sm:h-64 w-full object-cover shadow-lg"
            />
          </div>
        </div>

        <div ref={a.ref} className={`${a.className} order-1 lg:order-2`}>
          <p className="text-xs tracking-[0.4em] uppercase text-brand-gold mb-5">
            Pranic Healing
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-brand-plumDark mb-6 sm:mb-7 leading-tight">
            {t.intro.title}
          </h2>
          <p className="text-brand-ink/75 leading-relaxed mb-5">{t.intro.p1}</p>
          <p className="text-brand-ink/75 leading-relaxed mb-8">{t.intro.p2}</p>

          <p className="font-medium text-brand-plum mb-4">{t.intro.listTitle}</p>
          <ul className="space-y-3">
            {t.intro.list.map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-brand-sage/20 flex items-center justify-center">
                  <Check size={13} className="text-brand-sage" />
                </span>
                <span className="text-brand-ink/80">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Intro;
